export const messages = {
  en: {
    recommendGoods: {
      title: 'Recommend Goods',
      queryCondition: 'Query Condition',
      productName: 'Product Name',
      productId: 'Product ID',
      barCode: 'Bar Code',
      search: 'Search',
      recommendGoodsList: 'Recommend Goods List',
      chooseProduct: 'Choose Product',
      productImage: 'Product Image',
      createTime: 'Create Time',
      operation: 'Operation',
      delete: 'Delete',
      confirmDelete: 'Confirm Delete',
      deleteConfirmText: 'Are you sure to delete this recommend product?',
      cancel: 'Cancel',
      confirm: 'Confirm',
      chooseProductTitle: 'Choose Product',
      pleaseSelect: 'Please select at least one item'
    }
  },
  zh: {
    recommendGoods: {
      title: '推荐商品管理',
      queryCondition: '查询条件',
      productName: '商品名称',
      productId: '商品ID',
      barCode: '产品条形码',
      search: '查询',
      recommendGoodsList: '推荐商品列表',
      chooseProduct: '选择商品',
      productImage: '商品图片',
      createTime: '创建时间',
      operation: '操作',
      delete: '删除',
      confirmDelete: '确认删除',
      deleteConfirmText: '确定要删除该推荐商品吗？',
      cancel: '取消',
      confirm: '确定',
      chooseProductTitle: '选择商品',
      pleaseSelect: '请至少选择一条数据'
    }
  }
}